
export const radiusCover = [
    { label: "5 Miles", value: 5 },
    { label: "10 Miles", value: 10 },
    { label: "25 Miles", value: 25 },
    { label: "50 Miles", value: 50 },
    { label: "100 Miles", value: 100 },
    { label: "Nationwide", value: 101 }
]

// export const companySizeOptions = [
//     { label: "Sole Trader", value: "soleTrader" },
//     { label: "1-10 Employees", value: "1-10 Employees" },
//     { label: "11-50 Employees", value: "11-50 Employees" },
//     { label: "51 - 100 Employees", value: "51 - 100 Employees" },
//     { label: "100 + Employees", value: "100 + Employees" },
// ]

export const companytype = [
    { label: "Sole Trader", value: "soleTrader" },
    { label: "Limited Company", value: "LimitedCompany" }, // Corrected value
]
  
  export const LimitedCompanyOptions = [
    { label: "1-3 Employees", value: "1-3 Employees" },
    { label: "4-10 Employees", value: "4-10 Employees" },
    { label: "11-20 Employees", value: "11-20 Employees" },
    { label: "21 + Employees", value: "21 + Employees" },
  ];






export const reponceCount = [
    { bussinessName: "" },
    { bussinessName: ""},
    { bussinessName: "" },
    { bussinessName: "" },
    { bussinessName: "" },
]



export const decisionOptions = [
    { value: "1", label: "I will definitely hire someone" },
    { value: "2", label: "I will possibly hire someone" },
    { value: "3", label: "I'm just looking for a quote" },
    { value: "4", label: "I won’t hire anyone" },
  ];


  export const needOptions = [
    { value: "Asap", label: "ASAP" },
    { value: "Week", label: "Within a week" },
    { value: "Flexible", label: "Flexible" },
  ];
